<template>
	<div class="filters-box">
		<div class="filters-box-row">
			<div class="data-picker-box">
				<span>时间周期：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					type="daterange"
					:clearable='false'
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="order-type-box">
				<span>活动类型：</span>
				<el-select v-model="orderType" placeholder="请选择活动类型" class="order-type-select" size="small">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.value"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="order-group-box">
				<span>活动编号：</span>
				<el-input v-model="orderCode" placeholder="请输入活动编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-group-box">
				<span>活动名称：</span>
				<el-input v-model="orderName" placeholder="请输入活动名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<!-- <div class="filters-box-row">
			<div class="order-group-box">
				<span>采购门店名称：</span>
				<el-input v-model="orderGroupValue" placeholder="请输入采购门店名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-shop-box">
				<span>供货商店铺名称：</span>
				<el-input v-model="orderShopValue" placeholder="请输入供货商店铺名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div> -->
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			options: [
				{ value: '全部', id: '-1' },
				{ value: '满减', id: '0' },
				{ value: '拉新', id: '1' }
			],
			orderType: '-1',
			orderNOValue: '',
			orderGroupValue: '',
			orderShopValue: '',
			dateValue: [],
			orderName: '',
			orderCode: ''
		}
	},
	created () {
		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			let throughParams = this.$fxUtils.JSONparse(this.$route.query.throughParams)
			if (throughParams) {
				this.orderGroupValue = (throughParams.entname && throughParams.entname.value) || ''
				this.orderShopValue = (throughParams.shopName && throughParams.shopName.value) || ''
				let startDate = throughParams.startDate.value.split(' ')
				let endDate = throughParams.endDate.value.split(' ')
				this.orderType = throughParams.type.value
				this.dateValue = [startDate[0], endDate[0]]
			}
		} else {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
		}
	},
	methods: {
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			// if (this.orderNOValue) {
			// 	let orderNoObj = { 'field': 'orderNo', 'data': this.orderNOValue, 'op': 'cn' }
			// 	cParams.push(orderNoObj)
			// }
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'beginDate', data: `${this.$fxUtils.getCurrentMonthLast()} 23:59`, 'op': 'lt' },
					{ field: 'endDate', data: `${this.$fxUtils.getCurrentMonthFirst()} 00:00`, 'op': 'gt' }
				]
			} else {
				filtersParams = [
					{ field: 'beginDate', data: `${this.dateValue[1]} 23:59`, 'op': 'lt' },
					{ field: 'endDate', data: `${this.dateValue[0]} 00:00`, 'op': 'gt' }
				]
			}
			if (this.orderType !== '-1') {
				let orderTypeObj = { 'field': 'type', 'data': this.orderType, 'op': 'eq' }
				filtersParams.push(orderTypeObj)
			}
			if (this.orderName) {
				let orderGrpupObj = { 'field': 'name', 'data': this.orderName, 'op': 'cn' }
				filtersParams.push(orderGrpupObj)
			}
			if (this.orderCode) {
				let orderShopObj = { 'field': 'code', 'data': this.orderCode, 'op': 'cn' }
				filtersParams.push(orderShopObj)
			}
			return {
				filtersParams,
				cParams
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59`, 'op': 'le', type: 'filtersParams' }
			]
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	.filters-box-row {
		display:flex
		margin-bottom: 10px
		&:last-child {
			margin-bottom: 0px
		}
		.data-picker-box {
			margin-right:10px
		}
		.order-type-box {
			margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-group-box, .order-shop-box {
			.order-input {
				width:150px
			}
		}
		.order-group-box {
			margin-right:10px
		}
	}
}
</style>
